module.exports = __webpack_public_path__ + "static/media/2019 - 2020 theme logo.3fef495a.jpg";